module.exports = __webpack_public_path__ + "static/img/bg-overview@w.da2fb96.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/genesis-shop/bg-overview@w.jpg
// module id = jVn6
// module chunks = 0